import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { DataTableLayoutHost } from "@/modules/shell/DataTableChrome";
import { LifecycleLegend } from "./LifecycleStatus";
import type { LifecycleKind } from "./lifecycle-status";

/**
 * List chrome: lifecycle indicators + optional fulfillment complete mark — plan/30.
 * Posted (primary dot) ≠ Complete ✓ (ok green).
 * Table/stacked toggle mounts on the right via DataTableLayoutHost.
 */
export function DocListLegend(props: {
  kinds: LifecycleKind[];
  /** Show ✓ = paid/delivered/received complete (SO/PO lists). */
  showFulfillmentComplete?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mt-3 flex flex-wrap items-center gap-x-5 gap-y-2",
        props.className,
      )}
    >
      <LifecycleLegend kinds={props.kinds} />
      {props.showFulfillmentComplete ? (
        <p className="m-0 inline-flex items-center gap-1.5 text-xs text-[var(--color-ok)]">
          <Check className="size-3.5 shrink-0" strokeWidth={2.5} aria-hidden />
          <span className="text-[var(--color-muted)]">
            Complete (paid / delivered / received)
          </span>
        </p>
      ) : null}
      <DataTableLayoutHost />
    </div>
  );
}
